import { ChangeDetectorRef, Component, Input, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { NavController, ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EmployeeTooltipDialogComponent } from '../employee-tooltip-dialog/employee-tooltip-dialog.component';
import { createChart } from 'src/app/shared/commen-function-file';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { filter, Subscription } from 'rxjs';
import { calculateFiscalYear, formatYearRanges} from 'src/app/shared/commen-function-file';
import { ViewChildren, QueryList } from '@angular/core';




@Component({
  selector: 'app-nine-box-dashboard',
  templateUrl: './nine-box-dashboard.component.html',
  styleUrls: ['./nine-box-dashboard.component.scss'],
})
export class NineBoxDashboardComponent implements OnInit {
  @ViewChildren('multiSelect') dropdowns!: QueryList<any>;


  selectedTypeTabName: any = 'Dashboard';
  selectedTypeTabIndex: any;
  pmsYears: { year: string }[] = [];
  selectedYear: string = '';
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  loggedInUserName: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserCompanyID: any;
  loggedInUserRoles: any;
  loggedInUserRole: any;
  // selectedTypeTabName = ''; 
  fromYear: string = '';
  toYear: string = '';
  selectedYearForCompetency: any = null;
  dashboardData: any = [];
  departmentsColor: any = [];
  allDepartmentColor: any = [];
  getListOfDepartmentsOfComp: any = [];
  selectDepartmentsColor: any = [];
  buttonColorName: any;
  employeetrendAccrossyear: any[] = [];
  selectedDepartments: any = [];
  allDepartmentsList: any = [];
  isShowMD: any;
  selectedPerformanceDepartments: any = [];
  selectedperformancesBands: any[] = [];
  selectedPerformanceEmployee: any[] = [];
  bandListForPerformanceVsPotential: any[] = [];
  arrPerformanceVsPotential: any[] = [];
  arrEmployeesReport: any[] = [];
  performanceDta: any = [];
  fromDate: any;
  toDate: any;
  lowMediumHighPerformanceData: any = [];
  intHODempCode: any | null;
  arrHODByUserList: any = [];
  employeesData: any = [];
  selectedGraphEmployee: any = [];
  arrEmployeesData: any = [];
  selectedFromDated: any;
  selectedtoDated: any;
  subModuleButtonColor: any | null;
  selectedYearForGraphOneHRAdmin: any = null;
  selectedYearForGraphTwoHRAdmin: any = null;
  selectedYearForGraphFifthHRAdmin: any = null;
  selectedYearForGraphSix: any = null;
  selectedYearForGraphNineHRAdmin: any = null;
  selectedYearForGraphTenHRAdmin: any = null;
  performancePotentialLength: any;
  userIdsForSuperAdmin: any = [];
  loggedInUserDepartment: any | null;
  emptyDepartment: number = 1;
  isBandDeletedForUser: boolean = false;
  loggedInUserBand: any;
  bandNotFound: boolean = true;
dashboardGraphDataSubscription!: Subscription;

  constructor(private datePipe: DatePipe, public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<EmployeeTooltipDialogComponent>,
    private PdfDownload: PdfDownloadService,    private dataRefreshService: DataRefreshService,private navCtrl: NavController


  ) {    this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
 
    }
  });}
  private safeCloseAllDropdowns(): void {
  if (!this.dropdowns || !this.dropdowns.length) return;

  this.dropdowns.forEach((dd: any, idx: number) => {
    if (!dd) return;
    try {
      if (typeof dd.closeDropdown === 'function') { dd.closeDropdown(); return; }
      if (typeof dd.hideDropdown === 'function') { dd.hideDropdown(); return; }
      if (typeof dd.toggleDropdown === 'function') { dd.toggleDropdown(); return; }
      if (typeof dd.toggleDropdownList === 'function') { dd.toggleDropdownList(false); return; }

      // try some common wrapper properties
      const possible = [
        dd.dropdownRef,
        dd._dropdown,
        dd.el,
        dd.elementRef,
        dd.nativeElement,
        dd.dropdownElement,
      ];
      for (const p of possible) {
        if (!p) continue;
        if (typeof p.closeDropdown === 'function') { p.closeDropdown(); return; }
        if (typeof p.hideDropdown === 'function') { p.hideDropdown(); return; }
        if (p.nativeElement && typeof p.nativeElement.click === 'function') {
          try { p.nativeElement.click(); return; } catch {}
        }
      }

      // final-safe fallback: hide overlay DOM nodes (conservative)
      const panels = document.querySelectorAll('.ng-dropdown-panel, .ngx-dropdown-panel, .multiselect-dropdown');
      panels.forEach((pl: Element) => (pl as HTMLElement).style.display = 'none');
    } catch (err) {
      console.warn('safeCloseAllDropdowns: error closing dropdown', idx, err);
    }
  });
}



  ngOnInit() { 
   
    this.listenToRoute();

    this.cdRef.detectChanges();
    setTimeout(() => { 
    }, 1000);

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');

    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');


    this.loggedInUserDepartment = sessionStorage.getItem('department');


    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');

    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }

    this.activatedroute.queryParams.subscribe(params => {
      if (params['refresh']) {
        console.log("Detected refresh param:", params['refresh']);
        this.defaultCallFunctionsList();  // <-- This reloads your data
      }
    });
    if (this.loggedInUserRole == "Super Admin" || this.loggedInUserRole == "Admin" || this.loggedInUserRole == "HR Admin") {
      this.emptyDepartment = 1;
    } else {
      if (this.loggedInUserDepartment == 'null') {
        this.emptyDepartment = 0;
      }
    }

    this.intHODempCode = sessionStorage.getItem('empCode');

    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    // this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    // this.isShowMD = this.loggedInUserRoles.some((role: any) => role.name === 'MD');
 

    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") {
          // this.loggedInUserRoleIsEmployee = true
        }
      }
    }

  
    this.getpmsyearlist();
   
    // this.dataRefreshService.refreshNeeded$.subscribe(() => {
    //   this.router.events.subscribe(event => {
    //     if (event instanceof NavigationEnd && event.url.includes('/home/hrportal/nineBox')) {
        
    //       this.fetchKpiScore();
    //     }
       
    //   });});
   this.fetchKpiScore();
  }

    listenToRoute() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Call your method here
        this.refreshData();
      }
    });
  }

  refreshData() {
     this.getpmsyearlist();
    // your logic here
  }
 
   ionViewWillEnter() {
    console.log("LOAD Dashboard")
  }

  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/ninebox-log', { moduleName: moduleName, id: 0 }]);
    
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/nineBox', { operation: operation }]);
  }



  // ---------------------Start Fiscal Year----------------------------


  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = formatYearRanges(data?.data?.yearRanges);

  //     const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

  //     const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  
  //     this.setSelectedYear(yearValue);
    
  //   });
  // }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      const allYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;

      this.pmsYears = allYears.filter((yearObj: any) => {
        const [start] = yearObj.year.split('-').map(Number);
        return start <= fiscalStartYear;
      });


      const yearValue = currentFiscalYear;
      this.setSelectedYear(yearValue);
    });
  }




  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = this.selectedYearForCompetency = selectedYearObj.year;
      
      var test = this.selectedYearForCompetency?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }



  defaultCallFunctionsList() {
     
    // this.fetchKpiScore();
    this.fetchHODByUserList();
     this.getDashboardData();
    this.getDepartmentData();
    // (this.loggedInUserRole != "Employee" || this.loggedInUserRole != "Manager"  || this.loggedInUserRole != "MD" ) ? this.getDepartmentData() : null;
    
    this.getEmployeeTrends();
    this.getAllBoxbyCompany();
    if (this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") {
      this.getAllQuestions();
  
    } 
     
  }

 


  getAllQuestions() {

    this.httpService.callGetService(this.config.getEmployeeById + this.loggedInUserId).subscribe((data: any) => {
      let loggedInUserBand = data.data.band;

      let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;

      this.httpService.callGetService(this.config.getAllQuestions + fiscal_year + "/" + year + "/" + companyId).subscribe((resp: any) => {
        const arrAllQuestions = resp.data;


        const bandMatched = arrAllQuestions.filter((ques: any) => ques.band == loggedInUserBand);
        this.bandNotFound = bandMatched.length > 0 ? true : false;

      })


    });


  }


  // --------------------Update KPI/PMS Score  Score------------------------------ 

  fetchKpiScore() {

    this.pmsYears.forEach((results: any) => {
      let years = results.year;
      let arrYear = years?.split('-');

      if (arrYear?.length !== 2) {
     
        return;
      }

      const apiUrl = `${this.config.getAllEmployeeDumpReports}/${this.loggedInCompanyFiscalyear}/${years}/${this.loggedInUserCompanyID}`;

      this.httpService.callGetService(apiUrl).subscribe({
        next: (response: any) => {
          if (response && response.data) {
            const arrAllDumpReport = response.data;

            let userIdsForSuperAdmin = [];
            if (arrAllDumpReport.length != 0) {
              userIdsForSuperAdmin = arrAllDumpReport.map((emp: any) => emp.userId);

              let request = {
                "compId": this.loggedInUserCompanyID,
                "fromYear": Number(arrYear[0]),
                "month": [],
                "search": null,
                "toYear": Number(arrYear[1]),
                "userId": userIdsForSuperAdmin.map(String)
              };


              this.httpService.callPostService(this.config.getMonthYTDReport, request).subscribe((data: any) => {
                if (data.status) {
                  const employeesData = data?.data?.employeeResponse || [];
                  if (employeesData.length != 0) {

                    employeesData.forEach((emp: any) => {
                      if (emp.ytd) {
                        const resultUser = arrAllDumpReport.find((resp: any) => resp.employeeId == emp.employeeId);

                        if (resultUser) {
                          let intUserId = resultUser.userId
                          let kpiScore = emp.ytd;
                          let strYear = arrYear[0] + "-" + arrYear[1];

                          const payload = {
                            userId: parseInt(intUserId),
                            kpiScore: kpiScore,
                            year: strYear
                          };

                          this.httpService.callPutService(`${this.config.updateKpiScore}`, payload).subscribe(
                            (data: any) => {

                              console.log("UPDATE KPI SCORE")
                              this.getDashboardData();
                              // this.getPerformanceVsPotential();
                            },
                            (error: any) => {
                            
                            }
                          );

                        }
                      }

                    });

                  }

                }
              });


            }


          }
        },
        error: (err: any) => {
       
        }
      });


    });
  }



  // ---------------------End Fiscal Year----------------------------


//Change Fiscal Year 
  selectedYearForDashboard(year: any) {
    this.selectedYear = year;
    this.selectedYearForCompetency = year;

    this.getDashboardData();
    this.getDashboardGraphData('bar');
    
  }






  // -------------------------------------------Low Medium High Performance----------------------------------------------------------

  // for HOD By User List


  fetchHODByUserList() {
    let apiUrl = `${this.config.fetchHODByUserList}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.intHODempCode}&yearRange=${this.selectedYearForCompetency}&fiscalType=${this.loggedInCompanyFiscalyear}`;
    this.httpService.callGetService(apiUrl)
      .subscribe((resp: any) => {
        this.arrHODByUserList = resp.data.data;

      })

  }





  fetchLowMediumHighPerformance() {


    if (this.dashboardData.length == 0) {

      this.lowMediumHighPerformanceData = [
        {
          label: 'Low Performance',
          values: [
            { category: 'Low potential', count: 0, cssClassText: 'enigma1' },
            { category: 'Medium potential', count: 0, cssClassText: 'effective1' },
            { category: 'High Potential', count: 0, cssClassText: 'high-impact-performer1' }
          ]
        },
        {
          label: 'Medium Performance',
          values: [
            { category: 'Low potential', count: 0, cssClassText: 'under-performer1' },
            { category: 'Medium potential', count: 0, cssClassText: 'dilemma1' },
            { category: 'High Potential', count: 0, cssClassText: 'core-employee1' }
          ]
        },
        {
          label: 'High Performance',
          values: [
            { category: 'Low potential', count: 0, cssClassText: 'trusted-professional1' },
            { category: 'Medium potential', count: 0, cssClassText: 'future-leader1' },
            { category: 'High Potential', count: 0, cssClassText: 'growth-employee1' }
          ]
        }
      ];

      return;
    }



    const categoryOrder = ["Low performance", "Medium performance", "High performance"];
    const valueOrder = ["Low potential", "Medium potential", "High potential"];


    if (this.loggedInUserRole == "HOD") {

      // this.dashboardData = this.dashboardData.filter((item:any)=>item.department == this.selectedDepartments[0].name);
      let filteredData: any = {}; // Use an object to group employees by category
      let bandData: any = [];
      let employeeData: any = [];


      this.dashboardData.forEach((record: any) => {
        // Ensure the category exists in filteredData (default structure)
        if (!filteredData[record.label]) {
          record.label = record.label.replace(/(low potential|medium potential|high potential)/g, '').trim(), // Remove specific words
            filteredData[record.category] = {
              // category: record.category.split('-')[1],
              category: record.category,
              label: record.label,
              count: 0,
              employeeDetails: [],
              cssClassText: record.cssClassText
            };
        }

        if (record.employeeDetails && Array.isArray(record.employeeDetails)) {
          record.employeeDetails.forEach((employee: any) => {

            // Push the employee details into the already initialized category
            if (this.arrHODByUserList.some((hod: any) => hod.userId == employee.userId)) {
              bandData = this.getAllBandList(bandData, employee.band);
            }

            if (this.arrHODByUserList.some((hod: any) => hod.userId == employee.userId)) {
              employeeData.push(employee);
              filteredData[record.category].employeeDetails.push(employee);
              filteredData[record.category].count++; // Increment count
            }

          });
        }
      });



      // filteredData = Object.values(filteredData);
      filteredData = Object.values(filteredData)
        .sort((a: any, b: any) => categoryOrder.indexOf(a.label) - categoryOrder.indexOf(b.label)) // Sort categories
        .map((record: any) => {
          record.employeeDetails = record.employeeDetails.sort((a: any, b: any) =>
            valueOrder.indexOf(a.category) - valueOrder.indexOf(b.category) // Sort potential levels
          );
          return record;
        });


      const result = this.mergePerformanceData(filteredData);
      this.lowMediumHighPerformanceData = result;


    } else if (this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") {

      let filteredData: any = {}; // Use an object to group employees by category
      let bandData: any = [];
      let employeeData: any = [];

      this.dashboardData.forEach((record: any) => {
        // Ensure the category exists in filteredData (default structure)
        if (!filteredData[record.label]) {
          record.label = record.label.replace(/(low potential|medium potential|high potential)/g, '').trim(), // Remove specific words
            filteredData[record.category] = {
              // category: record.category.split('-')[1],
              category: record.category,
              label: record.label,
              count: 0,
              employeeDetails: [],
              cssClassText: record.cssClassText
            };
        }

        if (record.employeeDetails && Array.isArray(record.employeeDetails)) {
          record.employeeDetails.forEach((employee: any) => {
            // Push the employee details into the already initialized category

            if (this.loggedInUserId == employee.userId) {
              bandData = this.getAllBandList(bandData, employee.band);
            }
            if (this.loggedInUserId == employee.userId) {
              employeeData.push(employee);
            }

            if (this.loggedInUserId == employee.userId) {
              employeeData.push(employee);
              filteredData[record.category].employeeDetails.push(employee);
              filteredData[record.category].count++; // Increment count
            }


          });
        }
      });
      filteredData = Object.values(filteredData)
        .sort((a: any, b: any) => categoryOrder.indexOf(a.label) - categoryOrder.indexOf(b.label)) // Sort categories
        .map((record: any) => {
          record.employeeDetails = record.employeeDetails.sort((a: any, b: any) =>
            valueOrder.indexOf(a.category) - valueOrder.indexOf(b.category) // Sort potential levels
          );
          return record;
        });


      const result = this.mergePerformanceData(filteredData);
      this.lowMediumHighPerformanceData = result;
    } else {

      let filteredData: any = {}; // Use an object to group employees by category
      let bandData: any = [];
      let employeeData: any = [];

      this.dashboardData.forEach((record: any) => {
        // Ensure the category exists in filteredData (default structure)
        if (!filteredData[record.label]) {
          record.label = record.label.replace(/(low potential|medium potential|high potential)/g, '').trim(), // Remove specific words
            filteredData[record.category] = {
              // category: record.category.split('-')[1],
              category: record.category,
              label: record.label,
              count: 0,
              employeeDetails: [],
              cssClassText: record.cssClassText
            };
        }

        if (record.employeeDetails && Array.isArray(record.employeeDetails)) {
          record.employeeDetails.forEach((employee: any) => {
            // Push the employee details into the already initialized category
            bandData = this.getAllBandList(bandData, employee.band);

            employeeData.push(employee);
            filteredData[record.category].employeeDetails.push(employee);
            filteredData[record.category].count++; // Increment count


          });
        }
      });

     
      filteredData = Object.values(filteredData)
        .sort((a: any, b: any) => categoryOrder.indexOf(a.label) - categoryOrder.indexOf(b.label)) // Sort categories
        .map((record: any) => {
          record.employeeDetails = record.employeeDetails.sort((a: any, b: any) =>
            valueOrder.indexOf(a.category) - valueOrder.indexOf(b.category) // Sort potential levels
          );
          return record;
        });


      const result = this.mergePerformanceData(filteredData);
      this.lowMediumHighPerformanceData = result;
    }
  }




  mergePerformanceData(filteredData: any) {

    let finalData: any[] = [];

    if (filteredData.length > 0) {
      filteredData.forEach((item: any) => {
        let valuesArray: any[] = [];

        valuesArray.push({
          category: item.category,
          count: item.count,
          cssClassText: item.cssClassText,
          employeeDetails: item.employeeDetails = item.employeeDetails.filter((employee: any, index: any, self: any) =>
            index === self.findIndex((e: any) => e.userId === employee.userId)
          ), // Corrected Syntax
        });

        if (valuesArray.length > 0) {
          finalData.push({
            label: item.label,
            values: valuesArray,
          });
        }
      });
    }
    let finalData1: any = [];
    finalData.forEach((item: any) => {
      finalData1.push(item);
    });

    const mergedData: any = {};

    finalData1.forEach((entry: any) => {
      const label = entry.label;

      if (!mergedData[label]) {
        mergedData[label] = { label, values: [] };
      }

      entry.values.forEach((value: any) => {
        const existingCategory = mergedData[label].values.find((v: any) => v.category === value.category);

        if (existingCategory) {
          existingCategory.count += value.count;
          existingCategory.employeeDetails.push(...value.employeeDetails);
        } else {
          mergedData[label].values.push({ ...value });
        }
      });
    });

    return Object.values(mergedData);
  }




  // --------------------------------------------------------------------------------------------------------

  selectedGraphEmployeeChange(event: any) {
    this.selectedGraphEmployee = event;
    this.getDashboardGraphData('bar');
  }



  // get department list
  selectedDepartMent: any = []
  getDepartmentData(){
    const apiUrl = `${this.config.getemployeeDetails}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;
    
    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        let employeeData = response?.data || [];
        
        if (this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") {
            this.getDepartmentsList = [{ id: this.loggedInUserDepartment, name: this.loggedInUserDepartment }];

            employeeData = employeeData.filter((emp: any) => emp.department === this.loggedInUserDepartment);
  
        }else if (this.loggedInUserRole === 'HOD') {
          employeeData = employeeData.filter((emp: any) => this.arrHODByUserList?.some((hod: any) => hod?.userId === emp?.userId));
          employeeData = employeeData.filter((emp: any) => emp.department !== this.loggedInUserDepartment);
        } 
  

        const departmentCounts: any = {};
  
        employeeData.forEach((emp: any) => {
          const dept = emp.department;
  
          if (!departmentCounts[dept]) {
            departmentCounts[dept] = { total: 0, scored: 0 };
          }
  
          departmentCounts[dept].total += 1;
          if (emp.finalScore !== null && emp.finalScore !== undefined) {
            departmentCounts[dept].scored += 1;
          }
        });
  
        
  
        this.getDepartmentsList = Object?.keys(departmentCounts).map((dept) => {
          const counts = departmentCounts[dept];
          return {
            id: dept,
            // name: `${dept} (${counts.scored}/${counts.total})`
            name: (this.loggedInUserRole === 'Employee' || this.loggedInUserRole === 'Manager' || this.loggedInUserRole == "MD")
            ? dept
            : `${dept} (${counts.scored}/${counts.total})`
          };
        }).sort((a, b) => a.name.localeCompare(b.name));
  
    
        this.selectedDepartments.push(this.getDepartmentsList[0]);
        this.selectedDepartmentEmployeeTrends.push(this.getDepartmentsList[0]);
        this.selectedPerformanceDepartments = this.getDepartmentsList.slice(0, 1);
        this.forReportPerformanceVsPotential();
        this.saveKpiScore();
        this.syncEmployee();
      },
      error: (err: any) => {
       
      }
    });
  }
   


  saveKpiScore() {
    const companyId = this.loggedInUserCompanyID;
    const year = this.selectedYear || this.selectedYearForCompetency;
    const fiscalYear = this.loggedInCompanyFiscalyear;
  
  
    const url = `${this.config.saveKpiScore}/${fiscalYear}/${year}/${companyId}`;
  
   
    this.httpService.callPostService(url, {}).subscribe({
      next: async (result: any) => {
    
        console.log('KPI Score saved:', result);
      },
      error: async (err: any) => {
       
        console.error('Error saving KPI Score:', err);
      }
    });
  }

  
  syncEmployee() {
    const companyId = this.loggedInUserCompanyID;
    const year = this.selectedYear || this.selectedYearForCompetency;
    const fiscalYear = this.loggedInCompanyFiscalyear;
  
  
    const url = `${this.config.employeeSync}/${fiscalYear}/${year}/${companyId}`;
  
   
    this.httpService.callPostService(url, {}).subscribe({
      next: async (result: any) => {
    
        console.log('Sync Employeee:', result);
      },
      error: async (err: any) => {
       
        console.error('Error saving KPI Score:', err);
      }
    });
  }
  
  
  // ----------------------------------------Add Or Update Department Colour------------------------------------------------
  saveNineBox(eles: any) {

    this.selectDepartmentsColor.forEach((elm: any) => {
      this.httpService.callPostService(`${this.config.addOrUpdateBox}`, elm)
        .subscribe({
          next: async (result: any) => {
            this.getDepartmentsByCompany();
            this.openDialog('Department color added successfully', 'OK', this.buttonColorName, false, false, false);
          },
          error: async (err: any) => {
            this.openDialog(err.error.message, 'OK', 'red', false, false, false);
          }
        });
    });

  }
  openDialog(arg0: string, arg1: string, buttonColorName: any, arg3: boolean, arg4: boolean, arg5: boolean) {
    throw new Error('Method not implemented.');
  }
  // -----------------------------------------Add Or Update Department Colour-----------------------------------------------


  // ==================== Department color data  =====================


  async showToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      color: color,
      position: 'top'
    });
    await toast.present();
  }


  displayedgboxColumns: string[] = ['departmentName', 'departmentColor'];

  getDepartmentsByCompany() {
    this.httpService.callGetService(this.config.getDepartmentsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDepartmentsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          departmentName: ele,
          departmentColor: '#000000'
        }
        this.getListOfDepartmentsOfComp.push(obj);
      });

      this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
    })
  }



  getAllBoxbyCompany() {
    this.httpService.callGetService(this.config.getAllBoxbyCompanyId + this.loggedInCompanyFiscalyear + "/" + this.selectedYearForCompetency + "/" + this.loggedInUserCompanyID).subscribe((resp: any) => {
      this.departmentsColor = resp.data;

    });

  }


  checkDepartmentColor: any = [];

  changeColor(element: any) {
    console.log(`Change color for: ${element.departmentColor}`);

    element.companyId = this.loggedInUserCompanyID;
    element.year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
    element.fiscal_year = this.loggedInCompanyFiscalyear;
    element.changedByUserId = this.loggedInUserId;

    // Check if color already exists for another department
    const colorExists = this.checkDepartmentColor.some(
      (dept: any) => dept.departmentColor === element.departmentColor && dept.departmentName !== element.departmentName
    );

    if (colorExists) {
      console.log(`Color ${element.departmentColor} is already assigned to another department!`);
      this.showToast(`Color ${element.departmentColor} is already assigned to another department!`, 'danger');
      return;
    }

    // Remove duplicates based on departmentName
    this.checkDepartmentColor = this.checkDepartmentColor.filter(
      (dept: any, index: any, self: any) => index === self.findIndex((t: any) => t.departmentName === dept.departmentName)
    );

    // Check if color already exists for another department
    const colorExistsOnDatabase = this.allDepartmentColor.some(
      (dept: any) => dept.departmentColor === element.departmentColor && dept.departmentName !== element.departmentName
    );
    if (colorExistsOnDatabase) {
      console.log(`Color ${element.departmentColor} is already assigned to another department!`);

      this.showToast(`Color ${element.departmentColor} is already assigned to another department!`, 'danger');
      return;
    }
    // Add the new department
    this.checkDepartmentColor.push(element);
    this.selectDepartmentsColor = this.checkDepartmentColor;

  }

  openColorPicker(element: any) {
    // Logic to open a color picker or trigger a modal for color selection
    console.log("Open color picker for:", element);
  }
  // displayedThirdTableColumns: string[] = ['category', 'low', 'medium', 'high', 'action'];




  dataArray = [
    { band: 'option1', question: '', weight: '' },
    // Add initial rows if needed
  ];

  // Array to hold multiple tables
  tables: Array<any> = [
    {
      dataArray: [
        { band: '', question: '', weight: '' },
      ],
    },
  ];

  hideShowFlag: boolean = false;



  // ==============   9 box dashboard data  =====================

  
  
  
  // ****************9 box dropdwons *********************
  getDepartmentsList!: any[];
  selectedCount: number = 0;
  selectedCountForBand: number = 0;
  selectedCountForEmployee: number = 0;

  dropdownSettings = {
    singleSelection: false,  // or true based on your requirement
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };


  // Employee List
  currentEmployeeList: any[] = [];
  selectedEmployees: any[] = [];
  employeeList: any[] = []
  getEmployeeTrends() {
    const apiUrl = `${this.config.employeeTrendsReports + this.loggedInUserCompanyID}`;


    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {

        if (response && response.data) {
          // this.employeetrendAccrossyear = response.data;
          this.currentEmployeeList = response.data;
          this.employeeList = response.data;

          let departmentNames = this.selectedDepartmentEmployeeTrends.map((dept: any) => dept?.name);


          let filteredData = this.currentEmployeeList.filter((employee: any) =>
            departmentNames.includes(employee.department)
          );

          this.employeetrendAccrossyear = filteredData;

          this.extractBandsAndEmployees(this.employeetrendAccrossyear);
          this.selectedEmployeeTrends = this.extractBandsAndEmployees;
          // this.selectedtrendsBands = this.extractBandsAndEmployees;



        } else {
          console.warn("No trends data received");
          this.employeetrendAccrossyear = [];
        }
      },
      error: (err: any) => {
     
      }
    });
  }


  //departmentmentwise  filter

  selectedDepartmentEmployeeTrends: any = [];


  getSelectededEmployeeTrends() {
    this.trendFilterData();
  }

  getDeSelectedEMployeeTrends() {
    this.trendFilterData();
  }
  selectAllEmployeeTrends(event: any) {
    this.selectedDepartmentEmployeeTrends = event;


    this.trendFilterData();
  }

  onDeSelectAllEmployeeTrends() {
    this.selectedDepartmentEmployeeTrends = [];
    this.trendFilterData();

  }

  trendFilterData() {

    let departmentNames = this.selectedDepartmentEmployeeTrends.map((dept: any) => dept.name);

    let filteredData = this.currentEmployeeList.filter((employee: any) =>
      departmentNames.includes(employee.department)
    );

    this.employeetrendAccrossyear = filteredData;

    this.uniqueBands = [];
    this.uniqueEmployees = [];

    if (this.selectedDepartmentEmployeeTrends.length === 0) {
      return;
    }

    let filteredBands = filteredData.map((emp: any) => emp.band);
    this.uniqueBands = Array.from(new Set(filteredBands)).sort().map((band, index) => ({
      id: index,
      name: band
    }));


    this.extractBandsAndEmployees(this.employeetrendAccrossyear);
    this.selectedEmployeeTrends = this.extractBandsAndEmployees;
    // this.selectedtrendsBands = this.extractBandsAndEmployees;
  }



  // bandwise filter data
  selectedtrendsBands: any = [];


  
  bandDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };




  
  


  onBandSelect() {
    this.bandFilterData();

  }

  onBandDeSelect() {
    this.trendFilterData();
  }

  onSelectAllBands(event: any) {
    this.selectedtrendsBands = event;
    this.bandFilterData();
  }

  onDeSelectAllBands() {
    this.selectedtrendsBands = [];
    this.bandFilterData();
  }
  // Band-wise Filter Function
  bandFilterData() {

    if (!Array.isArray(this.selectedtrendsBands)) {
      this.selectedtrendsBands = [];
    }

    let departmentNames = this.selectedDepartmentEmployeeTrends.map((dept: any) => dept.name);
    let bandNames = this.selectedtrendsBands.map((band: any) => band.name);

    let filteredData = this.currentEmployeeList.filter((employee: any) =>
      departmentNames.includes(employee.department) && bandNames.includes(employee.band)
    );

    this.employeetrendAccrossyear = filteredData;


    this.uniqueEmployees = [];

    if (this.selectedtrendsBands.length === 0) {
      return;
    }

    this.uniqueEmployees = filteredData.map((emp, index) => ({
      id: index,
      name: emp.employee
    }));

    this.selectedEmployeeTrends = [];
  }




  //employeewise   filter
  uniqueBands: any[] = [];
  selectedBands: any[] = [];
  uniqueEmployees: any[] = [];


  employeeDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };


  extractBandsAndEmployees(data: any[]) {
    if (data && Array.isArray(data)) {
      this.uniqueBands = Array.from(new Set(data.map(emp => emp.band))).sort();

      // "All" ko remove kiya
      this.uniqueBands = this.uniqueBands.map((band, index) => ({
        id: index,
        name: band
      }));

      this.uniqueEmployees = data.map((emp, index) => ({
        id: index,
        name: emp.employee
      }));
    } else {
      this.uniqueBands = [];
      this.uniqueEmployees = [];
    }
  }


  selectedEmployeeTrends: any = [];



  // 9 Box dashboard data

  // Department wise filter
  getSelectedPerformanceVsPotential() {
    this.selectedCount = this.selectedPerformanceDepartments.length;
    this.forReportPerformanceVsPotential();

  }


  
  //performance vs potential : In Department wise filter  for onDeSelect
  getDeSelectedPerformanceVsPotential() {
    this.selectedCount = this.selectedPerformanceDepartments.length;

    if (this.selectedPerformanceDepartments.length == 0) {
      this.emptyReportPerformanceVsPotential();
    } else {
      this.selectedperformancesBands = [];
      this.selectedPerformanceEmployee = [];
      this.forReportPerformanceVsPotential(); //Performance vs Potential
    }
  }
  //performance vs potential : In Department wise filter  for selectAll
  selectAllPerformanceVsPotential(getDepartmentsList:any) {
    this.selectedCount = this.selectedPerformanceDepartments.length;
    this.selectedPerformanceDepartments = getDepartmentsList;
    this.selectedperformancesBands = [];
    this.selectedPerformanceEmployee = [];
    this.forReportPerformanceVsPotential();
  }
  //performance vs potential : In Department wise filter  for onDeSelectAll
  onDeSelectAllPerformanceVsPotential() {
    this.selectedCount = 0;
    this.selectedPerformanceDepartments = [];
    this.selectedPerformanceEmployee = [];
    this.selectedperformancesBands = [];
    this.bandListForPerformanceVsPotential = [];
    this.forReportPerformanceVsPotential();
  }
  //performance vs potential : In Department wise filter  for emptyReportPerformanceVsPotential
  emptyReportPerformanceVsPotential() {


    let filteredData: any = {}; // Use an object to group employees by category
    let bandData: any = [];
    let employeeData: any = [];

    this.dashboardData.forEach((record: any) => {
      // Ensure the category exists in filteredData (default structure)
      if (!filteredData[record.category]) {
        filteredData[record.category] = {
          category: record.category,
          count: 0,
          employeeDetails: [],
          cssClass: record.cssClass
        };
      }

    });

    this.arrEmployeesReport = []

    this.bandListForPerformanceVsPotential = [];
    this.selectedPerformanceEmployee = [];
    this.selectedperformancesBands = [];
    this.arrPerformanceVsPotential = Object.values(filteredData);


  }

  // Function to update count
  updateSelectedCount() {
    this.selectedCount = this.selectedPerformanceDepartments.length;
    this.selectedCountForBand = this.selectedperformancesBands.length;
    this.selectedCountForEmployee = this.selectedPerformanceEmployee.length;

  }
  //Band wise filter

  onPerformanceBandSelect() {
    this.selectedCountForBand = this.selectedperformancesBands.length;
    this.performanceBandFilterData();
  }

  onperformanceBandDeSelect(event: any) {
    this.selectedCountForBand = this.selectedperformancesBands.length;
    this.selectedPerformanceEmployee = [];
    this.performanceBandFilterData();
  }

  onSelectAllPerformanceBands(event: any) {
    this.selectedCountForBand = this.selectedperformancesBands.length;
    this.selectedperformancesBands = event;

    this.performanceBandFilterData();
  }

  onDeSelectAllPerformanceBands() {
    this.selectedCountForBand = 0;
    this.selectedperformancesBands = [];
    this.selectedPerformanceEmployee = [];
    this.arrEmployeesReport = [];
    this.performanceBandFilterData();
  }

  // Employee wise filter

  onPerformanceEmployeeSelect() {
    this.forReportPerformanceVsPotential();
  }

  onPerformanceEmployeeDeSelect() {
    this.forReportPerformanceVsPotential();
  }

  onSelectAllPerformanceEmployees(event: any) {
    this.selectedPerformanceEmployee = event;
    this.forReportPerformanceVsPotential();
  }

  onDeSelectAllPerformanceEmployees() {
    this.selectedPerformanceEmployee = [];
    this.forReportPerformanceVsPotential();
  }



  performanceBandFilterData() {

    if (!Array.isArray(this.selectedperformancesBands)) {
      this.selectedperformancesBands = [];
    }

    let departmentNames = this.selectedPerformanceDepartments.map((dept: any) => dept.name);
    let bandNames = this.selectedperformancesBands.map((band: any) => band.name);


    let filteredData = this.currentEmployeeList.filter((employee: any) =>
      departmentNames.includes(employee.department) && bandNames.includes(employee.band)
    );

    this.forReportPerformanceVsPotential();

  }



  forReportPerformanceVsPotential() {
    console.warn("forReportPerformanceVsPotential------")

    let filteredData: any = {}; // Use an object to group employees by category
    let bandData: any = [];
    let employeeData: any = [];
    let employeeDataForEmployeeTrends: any = [];
    let employeeDataForEmployeeTrendsHOD: any = [];

    if (this.dashboardData.length == 0) {
      this.arrPerformanceVsPotential = [
        { count: '0', category: 'Low performance & low potential', cssClass: 'enigma' },
        { count: '0', category: 'High performance & high potential', cssClass: 'growth-employee' },
        { count: '0', category: 'High performance & medium potential', cssClass: 'future-leader' },
        { count: '0', category: 'Low performance & medium potential', cssClass: 'effective' },
        { count: '0', category: 'Medium performance & high potential', cssClass: 'core-employee' },
        { count: '0', category: 'Low performance & high potential', cssClass: 'high-impact-performer' },
        { count: '0', category: 'Medium performance & low potential', cssClass: 'under-performer' },
        { count: '0', category: 'Medium performance & medium potential', cssClass: 'dilemma' },
        { count: '0', category: 'High performance & low potential', cssClass: 'trusted-professional' },
      ];
      return;
    }
    console.log(this.dashboardData);
            
    this.dashboardData.forEach((record: any) => {
      // Ensure the category exists in filteredData (default structure)
      if (!filteredData[record.label]) {
        filteredData[record.category] = {
          category: record.category,
          count: 0,
          employeeDetails: [],
          cssClass: record.cssClass
        };
      }

      if (record.employeeDetails && Array.isArray(record.employeeDetails)) {
        record.employeeDetails.forEach((employee: any) => {


          if (this.selectedPerformanceDepartments?.some((dept: any) => dept.id === employee.department)) {
              console.log("employee******",employee);
              
            // Push the employee details into the already initialized category
            if (this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") {
              if (this.loggedInUserId == employee.userId) {
                bandData = this.getAllBandList(bandData, employee.band);
              }
            } else if (this.loggedInUserRole == "HOD") {

              if (this.arrHODByUserList.some((hod: any) => hod.userId == employee.userId)) {
                console.log("-------------1----------",employee)
                bandData = this.getAllBandList(bandData, employee.band);
              }
            } else {
              console.log("-------------2----------",employee)
              bandData = this.getAllBandList(bandData, employee.band);
            }

            if (Array.isArray(this.selectedPerformanceEmployee) && this.selectedPerformanceEmployee.length > 0) {

              if (this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") {
                if (this.loggedInUserId == employee.userId) {
             
                  employeeData.push(employee);
                }
              } else if (this.loggedInUserRole == "HOD") {
                if (this.arrHODByUserList.some((hod: any) => hod.userId == employee.userId)) {
               
                  employeeData.push(employee);
                }
              }

              this.selectedPerformanceEmployee.forEach((emp: any) => {

                if (emp.name == employee.employeeName) {
               
                  filteredData[record.category].employeeDetails.push(employee);
                  filteredData[record.category].count++; // Increment count
                }

              });
            } else if (Array.isArray(this.selectedperformancesBands) && this.selectedperformancesBands.length > 0) {

           
              
              this.selectedperformancesBands.forEach((band: { name: string }) => {

                if (employee.band === band.name) {
                  // employee.departmentColor = this.departmentColorApply(employee.department);
                  employeeData.push(employee);

                  if (!filteredData[record.category]) {
                    filteredData[record.category] = { employeeDetails: [], count: 0 };
                  }
                  // employee.departmentColor = this.departmentColorApply(employee.department);
                  filteredData[record.category].employeeDetails.push(employee);
                  filteredData[record.category].count++; // Increment count
                }

              });


            } else {

              if (this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") {

                if (this.loggedInUserId == employee.userId) {

             
                  employeeData.push(employee);
             
                  filteredData[record.category].employeeDetails.push(employee);
                  filteredData[record.category].count++; // Increment count
                }
              } else if (this.loggedInUserRole == "HOD") {
          
                
                if (this.arrHODByUserList.some((hod: any) => hod.userId == employee.userId)) {
             

                  employeeData.push(employee);
             
                  filteredData[record.category].employeeDetails.push(employee);
                  filteredData[record.category].count++; // Increment count
                }
              } else {
              
                employeeData = this.getAllEmployeeList(employeeData, employee);
            
                filteredData[record.category].employeeDetails.push(employee);
                filteredData[record.category].count++; // Increment count
              }

            }

          }
       
        });
      }
    });




    const uniqueBandData = Array.from(new Set(bandData));

    this.bandListForPerformanceVsPotential = uniqueBandData .filter(emp => emp != null).map((emp: any, index: number) => ({
      id: index,
      name: emp
    }));


    if (employeeData.length > 0) {

      const uniqueEmployeesTrends = new Set();

      let employeeDataSource;

      if (["Super Admin", "Admin", "HR Admin"].includes(this.loggedInUserRole)) {
        employeeDataSource = employeeData;
      } else if (this.loggedInUserRole === "HOD") {
        employeeDataSource = employeeData;
      } else {
        employeeDataSource = employeeData;
      }

      this.arrEmployeesReport = employeeDataSource
        .filter((emp: any) => uniqueEmployeesTrends.has(emp.userId) ? false : uniqueEmployeesTrends.add(emp.userId))
        .map((emp: any, index: any) => ({
          id: index,
          userId: emp.userId,
          name: emp.employeeName
        }));


      this.selectedGraphEmployee = this.arrEmployeesReport[0]?.userId;
    }


    // (this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") ? this.selectedperformancesBands = [this.bandListForPerformanceVsPotential[0]] : null;
    // (this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") ? this.selectedPerformanceEmployee = [this.arrEmployeesReport[0]] : null;
   
    if (["Employee", "Manager", "MD"].includes(this.loggedInUserRole) && this.bandListForPerformanceVsPotential.length > 0) {
      this.selectedperformancesBands = [this.bandListForPerformanceVsPotential[0]];
    }
    
    if (["Employee", "Manager", "MD"].includes(this.loggedInUserRole) && this.arrEmployeesReport.length > 0) {
      this.selectedPerformanceEmployee = [this.arrEmployeesReport[0]];
    }
    

    this.arrPerformanceVsPotential = Object.values(filteredData);

    this.getDashboardGraphData('bar');

  }


  departmentColorApply(departmentName: any) {
    this.departmentsColor.map((dept: any) => {
      if (dept.departmentName == departmentName) {
        return dept.departmentColor;
      }
    })
  }

  getAllEmployeeList(employeeData: any, employee: any) {
    if (!employeeData[employee]) {
      employeeData.push(employee);
    }
    return employeeData;
  }

  getAllBandList(bandData: any, band: any) {
    if (!bandData[band]) {
      bandData.push(band);
    }
    return bandData;
  }


  // **************** 9 box dropdowns end*********************

 


  getDashboardData() {
    // this.loader.simpleLoader();
    const colorClasses = [
      "enigma", "growth-employee", "future-leader",
      "dilemma", "core-employee", "high-impact-performer",
      "under-performer", "effective", "trusted-professional"
    ];

    const colorClassesText = [
      "enigma1", "growth-employee1", "future-leader1",
      "dilemma1", "core-employee1", "high-impact-performer1",
      "under-performer1", "effective1", "trusted-professional1"
    ];
    let positions = [
      'Low performance high potential',
      'Medium performance high potential',
      'High performance high potential',
      'Low performance medium potential',
      'Medium performance medium potential',
      'High performance medium potential',
      'Low performance low potential',
      'Medium performance low potential',
      'High performance low potential',
    ];
    const apiUrl = `${this.config.getAllPerformancePotential}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        this.performancePotentialLength = response?.data?.length;

        if (response && response?.data) {
          const arrDashboardData = response?.data;

          arrDashboardData?.sort((a: any, b: any) => {
            return positions?.indexOf(a?.label) - positions?.indexOf(b?.label);
          });



          arrDashboardData?.forEach((item: any) => {
            // Remove duplicate employees based on userId

            item.employeeDetails = item.employeeDetails?.filter((employee: any, index: any, self: any) =>
              index === self?.findIndex((e: any) => e?.userId === employee?.userId)
            );
            item.count = item?.employeeDetails?.length
          });

          this.dashboardData = arrDashboardData?.map((cell: any, index: number) => ({
            ...cell,
            cssClassText: colorClassesText[index] || "default-cell",
            cssClass: colorClasses[index] || "default-cell" // Assigns a class to each cell
          }));

          // if (this.loggedInUserRole == "Super Admin" || this.loggedInUserRole == "Admin" || this.loggedInUserRole == "HOD" || this.loggedInUserRole == "HR Admin") {
          console.log("------------------456------------------------")
   
          // }

        } else {
          console.log("------------------789------------------------")
          this.forReportPerformanceVsPotential();
        }


        this.fetchLowMediumHighPerformance();

        // this.loader.dismissLoader();
        // this.forReportPerformanceVsPotential();

      },
      error: (err: any) => {

        //this.loader.dismissLoader();
      }
    });
  }


  // Function to return color class based on the category
  getCellColors(category: string) {
    const colorMapping: { [key: string]: string } = {
      "Enigma": "#F4D03F",
      "Growth Employee": "#2ECC71",
      "Future Leader": "#27AE60",
      "Dilemma": "#E67E22",
      "Core Employee": "#F39C12",
      "High Impact Performer": "#76D7C4",
      "Under Performer": "#E74C3C",
      "Effective": "#D35400",
      "Trusted Professional": "#F1C40F"
    };

    return { backgroundColor: colorMapping[category] || "#D5D8DC" }; // Default grey color
  }




  openEmployeeTooltip(value: any): void {



    console.log("departmentsColor in nine-box-dashboard", this.departmentsColor);


    const employees = Array.isArray(value.employeeDetails) ? value.employeeDetails : [];

    if (employees.length === 0) {
      console.warn("No employees found for:", value.label);
    }

    this.dialog.open(EmployeeTooltipDialogComponent, {
      data: {
        employees: value.employeeDetails || [],
        departmentsColor: this.departmentsColor || []

      },
      panelClass: 'phi_mdc_dialog__container_100',
      width: '75%',

      // position: {
      //   top: '5%',
      //   left: '20%'
      // }
    });
  }






  arrEmployeeWiseTrendsbyYear: any = [];
   
getDashboardGraphData(graphType: any) {

  const apiUrl = `${this.config.getDashboardGraphData}?companyId=${this.loggedInUserCompanyID}`;

  this.dashboardGraphDataSubscription = this.httpService.callGetService(apiUrl).subscribe({
    next: (response: any) => {
      if (response.status == true) {
        const employeeWiseTrendsbyYear = response.data;

        const transformedData = employeeWiseTrendsbyYear
          .filter((item: any) => item.userId === this.selectedGraphEmployee)
          .map((item: any) => ({
            xAxisValueData: item.year,
            seriesValueOneData: item.kpiScore,
            seriesValueTwoData: item.finalScore,
          }));

        this.arrEmployeeWiseTrendsbyYear = transformedData;
        transformedData['xAxisName'] = 'Year';
        transformedData['yAxisName'] = 'Score';
        transformedData['seriesLabelOne'] = 'Performance Score';
        transformedData['seriesLabelTwo'] = 'Potential Score';

        if (graphType == 'bar') {
          this.barChartActive(transformedData, 'bar-line-chart-nine-box', 'double');
        }
        if (graphType == 'line') {
          this.lineChartActive(transformedData, 'bar-line-chart-nine-box', 'double');
        }
      }
    },
    error: (error: any) => {
      console.error('Error fetching dashboard graph data:', error);
    }
  });
}

  isApprovedByFinanceIcon: any = 'bar';
  selectGraphTwoType: any = 'bar';
  isApprovedByFinanceTable: any = false;
  arrApprovedByFinanceTable: any = [];


  switchApprovedByFinanceGraph(graphType: any) {
    this.selectGraphTwoType = graphType;
    this.isApprovedByFinanceIcon = graphType;
    this.isApprovedByFinanceTable = false;
    if (graphType == 'bar') {
      this.getDashboardGraphData('bar');
    }
    if (graphType == 'line') {
      this.getDashboardGraphData('line');
    }

  }

  barChartActive(data: any, idSelector: any, graphType: any): void {
    createChart(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  // Usage for Line Chart
  lineChartActive(data: any, idSelector: any, graphType: any): void {
    createChart(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  switchApprovedByFinanceTable() {
    this.selectGraphTwoType = 'table';
    this.isApprovedByFinanceIcon = '';
    this.isApprovedByFinanceTable = true;

  }
  

  downloadChartAsPDF(type: any): void {
    const currentDate = new Date();
    const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;


    var idSelector = (this.selectGraphTwoType == 'table') ? 'table-employee-wise-trends-data' : 'bar-line-chart-nine-box';

    let selectedGraphEmployee = this.arrEmployeesReport.filter((item: any) => item.userId == this.selectedGraphEmployee);

    //Call the common function from the service
    this.PdfDownload.downloadPDF(
      idSelector, // chartId
      type, // Title
      selectedGraphEmployee[0]?.name, // Year
      "", // From Date
      "",
    );
  }



  downloadNineBoxPDF(type: any): void {
  const currentDate = new Date();
  const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

  const idSelector = 'nineBoxDash';

  // Close dropdowns safely first
  this.safeCloseAllDropdowns();

  // small delay to allow the UI to update (overlay close) before capturing PDF
  setTimeout(() => {
    this.PdfDownload.downloadPDF(
      idSelector,                // chartId
      'Performance vs Potential',// Title
      '',                       // Year
      '',                       // From Date
      ''                        // To Date / extra param
    );
  }, 80);
}



ngOnDestroy(): void {
  if (this.dashboardGraphDataSubscription) {
    this.dashboardGraphDataSubscription.unsubscribe();
  }
}




}





